// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3t0ta","footer":"ModalCreateQualiphyProcedure_footer__1oEwq","additionData":"ModalCreateQualiphyProcedure_additionData__1EvMM"};